import React from 'react';
import './PurchaseControls.css';

interface PurchaseModalProps {
  title: string;
  subtitle?: string;
  onClose: () => void;
  children: React.ReactNode;
}

const PurchaseModal: React.FC<PurchaseModalProps> = ({ title, subtitle, onClose, children }) => {
  return (
    <div className="purchase-controls">
      <div className="purchase-controls__header">
        <div className="purchase-controls__product-info">
          <h3>{title}</h3>
          {subtitle && <div className="purchase-controls__subtitle">{subtitle}</div>}
        </div>
        <button type="button" onClick={onClose} className="purchase-controls__close">×</button>
      </div>

      <div className="purchase-controls__form">
        {children}
      </div>
    </div>
  );
};

export default PurchaseModal;
